import StartCampaignModal from './StartCampaignModal';

export default StartCampaignModal;
